module.exports = __webpack_public_path__ + "static/media/gitlab.b941e6c3.png";